<div [class]="containerClass" class="language-selector">
  <!-- Modo select -->
  @if (variant === 'select') {
    <p-select
      (onChange)="changeLanguage($event.value)"
      [(ngModel)]="selectedLanguageValue"
      [options]="languages"
      [placeholder]="translatedPlaceholder"
      [showClear]="false"
      [styleClass]="'w-full ' + dropdownClass"
      optionLabel="label"
      optionValue="value"
      >
      <ng-template let-option pTemplate="item">
        <div class="flex items-center gap-2">
          <img [alt]="option.flag" [src]="option.flag" class="rounded-full" width="20" />
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
      <ng-template let-selectedOption pTemplate="selectedItem">
        <div class="flex items-center gap-2">
          <img
            [alt]="selectedLanguage?.label"
            [src]="getCurrentFlag()"
            class="rounded-full"
            width="20"
            />
          <span>
            {{ getLabelByValue(selectedLanguageValue) }}
          </span>
        </div>
      </ng-template>
    </p-select>
  }

  <!-- Modo toggle -->
  @if (variant === 'toggle') {
    <p-button
      (onClick)="toggleLanguage()"
      [label]="showLabel ? getCurrentLabel() : ''"
      [outlined]="true"
      [size]="size"
      [styleClass]="buttonClass + ' flex items-center justify-center p-1 rounded-full'"
      severity="secondary"
      >
      <ng-template pTemplate="icon">
        <img
          [alt]="selectedLanguage?.label"
          [src]="getCurrentFlag()"
          class="rounded-full"
          height="24"
          width="24"
          />
      </ng-template>
    </p-button>
  }

  <!-- Modo switch tipo iOS con banderas -->
  @if (variant === 'switch') {
    <p-toggleswitch
      (onChange)="switchLanguage()"
      [(ngModel)]="isEnglish"
      >
      <ng-template #handle let-checked="checked">
        <img [src]="getCurrentFlag()" alt="flag" class="rounded-full" height="20" width="20" />
      </ng-template>
    </p-toggleswitch>
  }
</div>
